import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";

export interface NightModeExitResponse {
  object: {
    id: number;
    overlay: string;
  };
}

@Injectable({
  providedIn: "root",
})
export class MirrorService {
  constructor(private http: HttpClient) {}

  getMirrorList() {
    return this.http.get(environment.baseURL + "userMirrors");
  }

  geAvailableLinkedDisplayList() {
    return this.http.get(environment.baseURL + "userMirrors");
  }

  getMirror(mirrorId: string): Observable<any> {
    return this.http.get(`${environment.baseURL}userMirrors/${mirrorId}`);
  }

  getMirrorDetails(macaddress: string) {
    return this.http.get(
      environment.baseURL + "mirrors/deviceId/" + macaddress,
    );
  }

  activateMirror(data: any) {
    return this.http.put(environment.baseURL + "mirrors/activateMirror", data);
  }

  resetMirror(macAddress: any) {
    return this.http.get(environment.baseURL + "mirrors/reset/" + macAddress);
  }

  renameMirror(mirrorDetail: any) {
    return this.http.put(environment.baseURL + "userMirrors", mirrorDetail);
  }

  updateUserMirror(mirrorDetail: any) {
    return this.http.put(environment.baseURL + "userMirrors", mirrorDetail);
  }

  getDeviceDetails(deviceId) {
    return this.http.get(environment.baseURL + "mirrors/deviceId/" + deviceId);
  }

  addDeviceId(data) {
    return this.http.post(environment.baseURL + "mirrors/saveMirror", data);
  }

  callToTestPortal(major, minor, macAddress) {
    return this.http.get(
      environment.portalBaseURL +
        "?major=" +
        major +
        "&minor=" +
        minor +
        "&macaddress=" +
        macAddress,
    );
  }

  getInitialSocketData(requestData: any) {
    return this.http.post(environment.baseSocketURL + "socket", requestData);
  }

  addBackgrundSetting(data) {
    return this.http.post(
      environment.baseURL + "mirrors/backgroundSetting",
      data,
    );
  }

  updateBackgrundSetting(data) {
    return this.http.put(
      environment.baseURL + "mirrors/backgroundSetting",
      data,
    );
  }

  updateOrientation(payload) {
    return this.http.put(
      environment.baseURL + "mirrors/mirrorOrientation",
      payload,
    );
  }

  updateTimeZoneId(timezoneId: string, userMirrorId: string) {
    const params = new HttpParams()
      .set("timeZone", timezoneId)
      .set("id", userMirrorId);
    return this.http.put(
      environment.baseURL + "userMirrors/timeZone",
      {},
      { params },
    );
  }

  updateTimeFormat(requestData: any) {
    return this.http.put(
      environment.baseURL + "mirrors/timeFormat",
      requestData,
    );
  }

  updateDeviceCode(requestData: any) {
    return this.http.put(
      environment.baseURL + "mirrors/deviceCode",
      requestData,
    );
  }

  createTemplate(requestData: any) {
    return this.http.post(
      environment.baseURL + "templates/createTemplate",
      requestData,
    );
  }

  removeTemplates(requestData: any) {
    return this.http.put(
      environment.baseURL + "templates/removeTemplates",
      requestData,
    );
  }

  applyTemplates(requestData: any) {
    return this.http.put(
      environment.baseURL + "templates/applyTemplate",
      requestData,
    );
  }

  updateGesture(requestData: any) {
    return this.http.put(environment.baseURL + "mirrors/gesture", requestData);
  }

  updateOverlay(requestData: any) {
    return this.http.put(environment.baseURL + "mirrors/overlay", requestData);
  }

  exitNightMode(deviceId: string): Observable<NightModeExitResponse> {
    return this.http.put<NightModeExitResponse>(environment.baseURL + 'mirrors/exitNightMode', { deviceId });
  }

  generatePreviewUrltoken(requestData: any) {
    return this.http.post(
      environment.baseURL + "mirrors/generatePreviewUrlToken",
      requestData,
    );
  }

  updateMirrorDisplaySequence(payload: any) {
    return this.http.put(
      environment.baseURL + "userMirrors/sortOrder",
      payload,
    );
  }

  updateLinkedDisplay(payload: any) {
    return this.http.put(
      environment.baseURL + "userMirrors/linkDisplay",
      payload,
    );
  }

  unlinkDisplay(payload: any) {
    return this.http.put(
      environment.baseURL + "userMirrors/unlinkedDisplay",
      payload,
    );
  }

  initializeScheduleTemplates(userMirrorId: string) {
    return this.http.get(
      environment.baseURL +
        "templates/initializeScheduleTemplates/" +
        userMirrorId,
    );
  }

  updateDataViewShortcutSwitch(payload: any) {
    return this.http.put(
      environment.baseURL + "userMirrors/dataViewShortcutSwitch",
      payload,
    );
  }

  updateLivePreviewEnabled(payload: any) {
    return this.http.put(
      environment.baseURL + "userMirrors/livePreviewEnabled",
      payload,
    );
  }
}
